<template>
    <div class="popup-header">
        <div class="popup-header__title">
            <div class="popup-header___text">{{ title }}</div>
        </div>
        <div class="popup-header__actions">
            <v-btn
                    color="primary"
                    fab
                    small
                    @click="$emit('click-close')"
                    elevation="0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {type: String, default: null}
        }
    }
</script>

<style lang="scss">
    .popup-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .popup-header__title {
            min-height: 30px;
            display: flex;
            align-items: center;
        }
        .popup-header___text {
            font-size: 18px;
            font-weight: 300;
        }
        .popup-header__actions {
            padding-left: 10px;
        }
    }
</style>